// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".imageLoader {\n  height: 40px;\n  width: 40px;\n}", "",{"version":3,"sources":["webpack://./src/ui/components/Image/image.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;AACF","sourcesContent":[".imageLoader {\n  height: 40px;\n  width: 40px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
